var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterImageForTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 2001,
    viewBox: "0 0 1440 2001",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_644_21219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1441 1097.5V2422V2435.5H1V1033L245 1162L624 1097.5L1077 1140.5L1441 1097.5Z",
    fill: "url(#paint0_linear_644_21219)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 803.5V2426H1441V465L1091 540L798 509.5L588 598L338.5 585.5L1 803.5Z",
    fill: "url(#paint1_linear_644_21219)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441 338.5V469.5V2426H1V0L351 75L644 44.5L1103.5 120.5L1441 338.5Z",
    fill: "url(#paint2_linear_644_21219)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.001 1694L540 1658L220.5 1645.5L96.5 1694L0 1766.5V2410.5H1102L977.501 1811L767.001 1694Z",
    fill: "url(#paint3_linear_644_21219)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.5 1875.5L1072 1760.5L1312 1732.5L1441 1799V2430L225.5 2398L737.5 1875.5Z",
    fill: "url(#paint4_linear_644_21219)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_644_21219",
    x1: 227.5,
    y1: 1385,
    x2: 1277,
    y2: 2352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0FDE2",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0FDE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_644_21219",
    x1: 541.5,
    y1: 854.5,
    x2: 1132.5,
    y2: 1853.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFE5",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3FFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_644_21219",
    x1: 558,
    y1: 811,
    x2: 679.5,
    y2: 54.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDFFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0FDE2",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_644_21219",
    x1: 415,
    y1: 1475,
    x2: 1342.5,
    y2: 1948.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9FFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFCEB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_644_21219",
    x1: 1331.5,
    y1: 1851.5,
    x2: 549.499,
    y2: 1999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0826295,
    stopColor: "#D2F8E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64F5A2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_644_21219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2001,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterImageForTop);
export default __webpack_public_path__ + "static/media/footer_image_for_top.3133d2c6c38a8d80158ec106785e1d8d.svg";
export { ForwardRef as ReactComponent };